import { get } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectPropertyCommonAreas = state => searchEntities(state, 'propertyCommonAreas', ['name']);

export const selectCommonAreaById = (state,id) => selectPropertyCommonAreas(state).find( d => d.id === id);